import React, { useState, useEffect } from "react";
import { DynamicFormProps, DynamicFieldProps, DynamicFieldItem } from "../../../model/dynamic-forms";
import DynamicField from "./DynamicField";
import DynamicFormGenerator from "../DynamicFormGenerator";
import styles from "./DynamicForm.module.scss";

const DynamicForm: React.FC<DynamicFormProps> = (props) => {
	const { sectionDefinition, preselectedFormValues, isSubmitted, formStateChanged, isReadOnly = false } = props;
	const [fieldValues, setFieldValues] = useState<DynamicFieldItem[]>(preselectedFormValues || []);

	useEffect(() => {
		// Initialize with preselected values
		if (preselectedFormValues && preselectedFormValues.length > 0) {
			setFieldValues(preselectedFormValues);
		}
	}, [preselectedFormValues]);

	const handleFieldValueChanged = (value: DynamicFieldItem) => {
		// Don't allow changes if form is read-only
		if (isReadOnly) {
			return;
		}

		// Update field values
		const updatedFieldValues = [...fieldValues];
		const index = updatedFieldValues.findIndex((item) => item.fieldId === value.fieldId);

		if (index !== -1) {
			updatedFieldValues[index] = value;
		} else {
			updatedFieldValues.push(value);
		}

		setFieldValues(updatedFieldValues);

		// Notify parent if callback provided
		if (formStateChanged) {
			// For now, we'll assume form is valid if all required fields are filled
			// A more sophisticated validation can be added later
			const isFormValid = true; // Simplified - can be enhanced with actual validation
			formStateChanged(updatedFieldValues, isFormValid);
		}
	};

	return (
		<div className={styles.dynamicForm}>
			{sectionDefinition.attributeDefinitions
				.filter((attr) => attr.isEnabled !== false)
				.sort((a, b) => (a.displayOrder || 0) - (b.displayOrder || 0))
				.map((attributeDefinition) => {
					const preselectedFormValue = DynamicFormGenerator.preselectDynamicFieldValue(
						attributeDefinition.id,
						fieldValues
					);

					const fieldProps: DynamicFieldProps = {
						attributeDefinition,
						fieldValueChanged: handleFieldValueChanged,
						isSubmitted,
						preselectedFormValue,
						isReadOnly,
					};

					return <DynamicField key={attributeDefinition.id} {...fieldProps} />;
				})}
		</div>
	);
};

export default DynamicForm;

